// Func = limiting Scope for this file
// if ('NodeList' in window && !NodeList.prototype.forEach) {
//     console.info('polyfill for IE11');
//     NodeList.prototype.forEach = function (callback, thisArg) {
//         thisArg = thisArg || window;
//         for (let i = 0; i < this.length; i++) {
//             callback.call(thisArg, this[i], i, this);
//         }
//     };
// }


var lastScrollTop = 0;

const HEADER_LOGO = document.getElementById('jsLogo');

(function(){

	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	// avoid fancybox breaks slider.
	let internalGallery = $(".gallery-slides a");
	$(".gallery-slides a").on("click", function (e) {
	  e.preventDefault();
  
	  var totalSlides = +$(this).parents(".gallery-slides").slick("getSlick")
		  .slideCount,
		dataIndex = +$(this).parents(".gallery-slides").data("slick-index"),
		trueIndex;
	  switch (true) {
		case dataIndex < 0:
		  trueIndex = totalSlides + dataIndex;
		  break;
		case dataIndex >= totalSlides:
		  trueIndex = dataIndex % totalSlides;
		  break;
		default:
		  trueIndex = dataIndex;
	  }
	  $.fancybox.open(internalGallery, {}, trueIndex);
  
	  //console.log($(this).attr('data-slick-index'))
	  $(".gallery-slides").slick("slickGoTo", $(this).attr("data-image"));
  
	  return false;
	});
	//
  


    $('.sym-slides').slick({
        accessibility: false
    });

	$('.gallery-slider').on('afterChange', function(event, slick, currentSlide){

		$(this).parent().removeClass('moving');
		$('.gallery-block__text').removeClass('moving')

		if(currentSlide == $('.gallery-slider').attr('data-images')){
			$('.gallery-block__arrows .slick-next').attr('disabled','disabled');
		} else {
			if(currentSlide == 0){
				$('.gallery-block__arrows .slick-prev').attr('disabled','disabled');
			} else {
				$('.gallery-block__arrows .slick-next').removeAttr('disabled');
				$('.gallery-block__arrows .slick-prev').removeAttr('disabled');
			}
			
		}
		
	  });
	  $('.gallery-slider').on('beforeChange', function(event, slick, currentSlide){

		$(this).parent().addClass('moving')
		$('.gallery-block__text').addClass('moving')
		
		
	  });
	 
	 

	if(document.getElementById('burgerMenu')){
		let headerOption = 0;
		document.getElementById('burgerMenu').addEventListener('click', function(){
			
			let TEXT = this.getElementsByClassName('text')[0];
			if(this.classList.contains('open')){
				this.classList.remove('open')
				TEXT.innerHTML = 'Menu'
				document.getElementById('navContainer').classList.remove('open');
				document.getElementById('header').classList.remove('nav');
				if(headerOption == 1){
					headerOption = 0;
					document.getElementById('header').classList.add('scroll')
				}
			} else {
				this.classList.add('open')
				TEXT.innerHTML = 'Close'
				document.getElementById('navContainer').classList.add('open');
				document.getElementById('header').classList.add('nav');

				if(document.getElementById('header').classList.contains('scroll')){
					headerOption = 1;
					document.getElementById('header').classList.remove('scroll')
				}
				if(document.getElementById('mobileClose')){
					document.getElementById('mobileClose').classList.remove('hidden')
				}
			}
		})
		if(document.getElementById('mobileClose')){
			document.getElementById('mobileClose').addEventListener('click',function(){
				this.classList.add('hidden')
				document.getElementById('navContainer').classList.remove('open');
				document.getElementById('header').classList.remove('nav');
				document.getElementById('burgerMenu').getElementsByClassName('text')[0].innerHTML = 'Menu'
				if(headerOption == 1){
					headerOption = 0;
					document.getElementById('header').classList.add('scroll')
				}
			})
		}
	}

	//// Forms animation for labels
	//email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

	if(document.getElementById('navImages')){
		
		let allMainLinks = document.getElementById('primary-nav').querySelectorAll('li')
		let allMainImages = document.getElementById('navImages').querySelectorAll('figure')

		allMainLinks.forEach((link,index) => {
			
			link.addEventListener('mouseenter',function(){
				if(allMainImages[index] !== undefined){
					allMainImages[index].classList.add('active')
				}
			})
			link.addEventListener('mouseleave',function(){
				if(allMainImages[index] !== undefined){
					allMainImages[index].classList.remove('active')
				}
			})

			let linkA = link.querySelectorAll('a')[0];
			if(linkA.classList.contains('active')){
				if(allMainImages[index] !== undefined){
					allMainImages[index].classList.add('active')
				}
			}

		});

	}

	document.addEventListener("DOMContentLoaded", function () {
		var jsMenu = document.querySelector(".js-menu");
		var headerMenu = document.querySelector(".header-menu");
		var headerFather = document.querySelector(".header");
	
		jsMenu.addEventListener("click", function () {
			jsMenu.classList.toggle("active");
			headerMenu.classList.toggle("active");
			headerFather.classList.toggle("menu-display");
		});
	});

	//for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	//hover Menu
	var currentMenuItem = $("#privary-navigation a.active").parent().index();
	console.log(currentMenuItem);
	$(".menu-hovers .slide:eq(" + currentMenuItem + ")").addClass("active");
	$("#privary-navigation a").hover(function () {
		var hoverItem = $(this).parent().index();
		console.log(hoverItem);
		$(".menu-hovers .slide").removeClass('active');
		$(".menu-hovers .slide:eq(" + hoverItem + ")").addClass("active");
	});


	//Counter Menu
	var ul = document.querySelector('.privary-navigation__list');
	var elementsLi = ul.querySelectorAll('li');

	elementsLi.forEach(function (elemento, index) {
		var counter = document.createElement('span');
		counter.className = 'counter';
		counter.textContent = (index + 1);

		elemento.appendChild(counter);
	});


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			let altLogo = HEADER_LOGO.dataset.alt;
			let sourceLogo = HEADER_LOGO.getAttribute('src');
			changeLogo(altLogo,sourceLogo)
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			let altLogo = HEADER_LOGO.dataset.alt;
			let sourceLogo = HEADER_LOGO.getAttribute('src');
			changeLogo(altLogo,sourceLogo)
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeLogo(src,alt) {
	HEADER_LOGO.setAttribute('src',src);
	HEADER_LOGO.setAttribute('data-alt',alt);
}

function onLoad(){

	convertBtn();

	//Check anchor on URL
	let anchorHref = window.location.href;
	if(anchorHref.indexOf('#') > 0){
		if(anchorHref.split('#').length === 2){
			let windowTarget = anchorHref.split('#')[1];
			if(document.getElementById(windowTarget)){
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	if((!document.getElementById('gallery') && !document.getElementById('attractions')) && (document.getElementsByClassName('no-hero').length < 1)){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	} else {
		document.getElementById('header').classList.add('scroll');
		let altLogo = HEADER_LOGO.dataset.alt;
		let sourceLogo = HEADER_LOGO.getAttribute('src');
		changeLogo(altLogo,sourceLogo)
	}
	
}


function convertBtn() {
	if (document.getElementsByClassName('btn').length > 0) {
		let ALL_BTNS = document.querySelectorAll('.btn');
		ALL_BTNS.forEach((btn) => {
			if (btn.getAttribute('type') !== 'submit') {
				let INNER_TEXT = btn.innerHTML;
				btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
			}
		});
	}
}


//vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
